import { Loader } from '@googlemaps/js-api-loader';

let loaderInstance: Loader | null = null;
let loadPromise: Promise<typeof google> | null = null;

export const getGoogleMapsLoader = (): Promise<typeof google> => {
  if (loadPromise) {
    return loadPromise;
  }

  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

  // Check if API key is missing or is the placeholder
  if (!apiKey || apiKey === 'YOUR_GOOGLE_MAPS_API_KEY_HERE') {
    return Promise.reject(new Error(
      'Google Maps API key is missing. Please add VITE_GOOGLE_MAPS_API_KEY to your .env file. ' +
      'Get your API key from: https://console.cloud.google.com/google/maps-apis'
    ));
  }

  if (!loaderInstance) {
    loaderInstance = new Loader({
      apiKey,
      version: 'weekly',
      libraries: ['places'],
    });
  }

  loadPromise = loaderInstance.load().catch((error) => {
    // Reset the promise so it can be retried
    loadPromise = null;
    loaderInstance = null;
    throw error;
  });

  return loadPromise;
};
